<template>
    <b-modal id="logwin" title="Журнал нагрузки" ok-only ok-title="Закрыть" :ok-disabled="!!deleting" :no-close-on-esc="!!deleting" :no-close-on-backdrop="!!deleting">
      <p v-if="winLog.workName" class="lw-work">{{ winLog.workName }}</p>
      <table class="table lw-table">
        <thead>
          <tr>
            <th scope="col">Дата</th>
            <th scope="col">Кол-во</th>
            <th scope="col">Кабинет</th>
            <th scope="col" title="Утверждено">Утв.</th>
            <th v-if="canDelete" scope="col"><span class="visually-hidden">Удаление</span></th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(item, id) in winLog.log">
            <tr :key="id" class="small" :class="{ 'lw-gone': deleted[entryId(item)] }">
              <th scope="row">{{ item[0] }}</th>
              <td>{{ item[1] }} ч.</td>
              <td>{{ item[2] }}</td>
              <td>
                <b-icon v-if="approved(item)" icon="check2-square" class="lw-ok" aria-label="утверждено" title="Утверждено — удалить нельзя"></b-icon>
                <span v-else class="lw-dim" title="Не утверждено">—</span>
              </td>
              <td v-if="canDelete" class="lw-act">
                <span v-if="deleted[entryId(item)]" class="lw-done">✓ удалено</span>
                <button v-else-if="!approved(item) && entryId(item)" type="button" class="lw-del" :disabled="!!deleting"
                  :title="'Удалить из ISS запись ' + item[0]" @click="remove(item)">
                  <b-spinner v-if="deleting === entryId(item)" small></b-spinner><b-icon v-else icon="trash" aria-label="Удалить из ISS"></b-icon>
                </button>
              </td>
            </tr>
            <tr v-if="errors[entryId(item)]" :key="id + '-err'" class="small">
              <td :colspan="canDelete ? 5 : 4" class="lw-err" role="alert">Не удалено: {{ errors[entryId(item)] }}</td>
            </tr>
          </template>
        </tbody>
      </table>
      <p v-if="canDelete" class="lw-hint">Удалить можно только неутверждённые записи ISS. Перед удалением сервис попросит подтверждение.</p>
      <p v-else-if="winLog.log && winLog.log.length" class="lw-hint">Чтобы удалять записи, отправьте занятие в журнал ещё раз — журнал работы загрузится заново.</p>
    </b-modal>
</template>

<script>
const PATH = process.env.VUE_APP_PATH

// Журнал работы ISS для занятия («Занятие уже записано»): записи с отметкой
// «Утв.» и удаление неутверждённых (/api/iss/worklist/delete).
// winLog: {log: строки лога ISS, work: номер работы, workName, auth}
export default {
  name: 'logWin',
  props: {
    winLog: Object,
  },
  data() {
    return { deleting: null, deleted: {}, errors: {} }
  },
  computed: {
    canDelete() {
      return Number.isInteger(this.winLog.work) && !!this.winLog.auth
    },
  },
  watch: {
    'winLog.log'() {
      this.deleted = {}
      this.errors = {}
    },
  },
  methods: {
    // строка лога ISS: {0: дата+время, 1: часы, 2: аудитория, 4: утверждена, 5: ID}
    approved(item) {
      return item[4] === true || item[4] === 'true'
    },
    entryId(item) {
      return item[5] != null ? String(item[5]) : ''
    },
    async remove(item) {
      const id = this.entryId(item)
      const [date, t] = String(item[0]).split(' ')
      const time = String(t || '').split(':').slice(0, 2).join(':')
      const ok = await this.$bvModal.msgBoxConfirm(
        `Удалить из ISS запись ${date} ${time}, ${item[1]} ч${this.winLog.workName ? ' — «' + this.winLog.workName + '»' : ''}? Отменить удаление нельзя.`,
        { title: 'Удаление записи ISS', okTitle: 'Удалить', okVariant: 'danger', cancelTitle: 'Отмена', centered: true, size: 'sm' })
      if (!ok) return
      this.deleting = id
      this.$delete(this.errors, id)
      try {
        const { data } = await this.axios.post(PATH + '/api/iss/worklist/delete', {
          auth: this.winLog.auth,
          data: { id: this.winLog.work, date, time, entryId: Number(id), name: this.winLog.name },
        }, { timeout: 90000 })
        if (data.deleted) {
          this.$set(this.deleted, id, true)
          this.$emit('entry-deleted', { name: this.winLog.name, date, time, hours: Number(item[1]) || 2 })
        } else {
          this.$set(this.errors, id, data.error || 'ISS не подтвердил удаление.')
        }
      } catch (e) {
        this.$set(this.errors, id, (e.response && e.response.data && e.response.data.error) ||
          (e.code === 'ECONNABORTED' ? 'ISS не ответил вовремя — проверьте журнал работы.' : 'Сервер не ответил.'))
      } finally {
        this.deleting = null
      }
    },
  },
}
</script>

<style scoped>
.lw-work { font-weight: 600; margin-bottom: 6px; }
.lw-table th, .lw-table td { vertical-align: middle; }
.lw-ok { color: var(--success); }
.lw-dim { color: var(--text-muted); }
.lw-act { text-align: right; white-space: nowrap; }
.lw-del {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: 1px solid var(--border);
  border-radius: 4px;
  background: var(--bg-elevated);
  color: var(--danger);
  cursor: pointer;
}
.lw-del:hover:not(:disabled) { background: var(--color-busy-bg); border-color: var(--danger); }
.lw-del:disabled { opacity: .5; cursor: default; }
.lw-done { color: var(--success); font-weight: 600; font-size: 12px; }
.lw-gone th, .lw-gone td:not(.lw-act) { text-decoration: line-through; color: var(--text-muted); }
.lw-err { color: var(--danger); font-weight: 600; border-top: 0; padding-top: 0; }
.lw-hint { font-size: 12px; color: var(--text-muted); margin: 0; }
</style>
